import { useDispatch } from "react-redux";
import { authActions } from "../store/authSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const useHttp = () => {
  //待解決： 如何知道token過期？ 如何使用refreshToken去產生新token?

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const firebasePost = async (type, data) => {
    let url, option;
    let status = "PENDING";

    if (type === "CREATE") {
      url = "http://localhost:3030/user";
      option = {
        method: "POST",
        url: url,
        data: {
          email: data.email,
          password: data.password,
          subscription: true,
          firstName: data.firstName,
          lastName: data.lastName,
        },
        headers: {
          "Content-Type": "application/json",
        },
      };
    }
    if (type === "LOGIN") {
      url = "http://localhost:3030/login";
      option = {
        method: "POST",
        url: url,
        data: {
          email: data.email,
          password: data.password,
        },
        headers: {
          "Content-Type": "application/json",
        },
      };
    }

    try {
      const res = await axios(option);
      let responseOK = res && res.status === 200 && res.statusText === "OK";
      console.log(responseOK);

      //handle Error
      if (!responseOK) {
        throw new Error("Something went wrong...");
        status = "ERROR";
      }

      //handle Success
      status = "SUCCESS";
      const data = await res.data;

      if (type === "CREATE") {
        const {
          stsTokenManager: { accessToken: token, expirationTime: expiration },
        } = data;

        const ms = Math.abs(Date.now() - expiration);
        localStorage.setItem("token", token);
        localStorage.setItem("expiration", ms);

        setTimeout(() => {
          dispatch(authActions.logout());
        }, ms);
        dispatch(authActions.login(token, ms));
      }

      if (type === "LOGIN") {
        const { accessToken: token, expirationTime: expiration } = data;
        localStorage.setItem("token", token);
        localStorage.setItem("expiration", expiration);

        dispatch(authActions.login(token, expiration));
      }

      navigate("/", { replace: true });
      console.log(status);
      return status;
    } catch (err) {
      console.error(err.message);
    }
  };

  return firebasePost;
};

export default useHttp;
